export default "__VITE_ASSET__Sl8PNLXf__"